export const APP_URL = process.env.REACT_APP_URL ?? 'admin.asistme.ai'
export const API_URL = process.env.REACT_APP_API_URL ?? 'https://api.asistme.ai'
